<lfw-form-view-toolbar>
  <ng-container toolbar-left>
    <lfw-toolbar-text text="{{ 'COMMANDS.OFFLINEORDERS' | translate }}" />
  </ng-container>

  <ng-container toolbar-right>
    <lfw-toolbar-button
      class="desktop-only"
      label="{{ 'COMMANDS.INFO' | translate }}"
      icon="info"
      (click)="openInfo()" />

    @if (showOnlyOnline()) {
      <lfw-toolbar-divider class="desktop-only" />
      <lfw-toolbar-button
        class="desktop-only"
        label="{{ 'DIALOGS.CLOSE' | translate }}"
        icon="close"
        (click)="close()" />
    }

    <button class="mobile-only" mat-icon-button [matMenuTriggerFor]="infoMenu">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu class="mobile-only" #infoMenu="matMenu" yPosition="below">
      <button mat-menu-item (click)="openInfo()">
        <mat-icon>info</mat-icon>
        <span>{{ 'COMMANDS.INFO' | translate }}</span>
      </button>
      @if (showOnlyOnline()) {
        <button mat-menu-item (click)="close()">
          <mat-icon>close</mat-icon>
          <span>{{ 'DIALOGS.CLOSE' | translate }}</span>
        </button>
      }
    </mat-menu>
  </ng-container>
</lfw-form-view-toolbar>

@if (orders$) {
  <mat-nav-list class="selection-list">
    @for (order of orders$ | async | keyvalue; track order) {
      <mat-list-item class="selection-item">
        <lfw-offline-order-list-item [offlineOrder]="order.value"></lfw-offline-order-list-item>
      </mat-list-item>
    }
  </mat-nav-list>
}
